module.exports = __webpack_public_path__ + "img/bar-chart.e268c8b6.svg";